(ns frontend.test.chart.view
  (:require
   [reagent.core :as r]
   [ui.color :as c]
   [ui.components.chart.view :as chart]))

(defn view
  []
  (let [data (r/atom [1 3 1 7 12])]
    (js/setInterval (fn []
                      (reset! data (vec (concat @data [(rand-int 10)]))))
                    10000)
    (fn []
      [chart/view
       {:chart  {:type            "spline"
                 :backgroundColor {:linearGradient {:x1 0
                                                    :y1 0
                                                    :x2 1
                                                    :y2 1}
                                   :stops          [[0 (c/color ::c/bg-1)]
                                                    [1 (c/color ::c/bg-2)]]}}
        :title  {:text "My chart"}
        :series [{:data @data}]}])))
